/* eslint-disable max-len */
/* eslint-disable no-console */
import { Box, Tooltip, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { LanguageContext } from '../../../../../../libs/Context';
import CreationFieldPopUp from '../../FeedCreation/CreationPopup';
import useGetFeedPermissions from '../../../CustomHooks/useGetFeedPermissions';
import { useSelector } from 'react-redux';

const RepostButton = (props) =>
{
	const { feed, delCloseGetApi } = props;
	const { language } = useContext(LanguageContext);
	const [ repost, setRepost ] = useState(false);
	const [ count, setCount ] = useState(feed?.repostCount);

	const userData = useSelector((state:any) => state.mysession.session);
	const getPermission = useGetFeedPermissions(feed, userData);
	const disableRepost = feed?.repostObj?.feedId || [ 'occasion', 'poll' ].includes(feed?.feedType) || !getPermission('repost');

	if (disableRepost) return <></>;

	const toggleRepostPopup = () =>
	{
		if (!disableRepost)
		{
			setRepost(!repost);
		}
	};

	const handleRepostCallback = () =>
	{
		delCloseGetApi
			? delCloseGetApi(true)
			: setCount((prev) => (prev + 1));
	};

	return (
		<Box display='flex' alignItems='center'>
			<Tooltip title={language.rePost} placement='top'>
				<Box
					onClick={toggleRepostPopup}
					component='img'
					src='/images/icons/Images/repost.svg'
					alt='Icon'
					height={'var(--pixel20)'}
					width={'var(--pixel20)'}
					sx={{ marginRight : 0.5,
						...(disableRepost ? { pointerEvents: 'none', opacity: 0.3 } : { cursor: 'pointer' }),
						'&:hover'   : {
							backgroundColor : 'transparent',
							filter          : 'invert(49%) sepia(98%) saturate(365%) hue-rotate(145deg) brightness(93%) contrast(92%)',
							transform       : 'scale(1.2)'
						}
					}}
				/>
			</Tooltip>
			{count !== undefined && count !== null && count !== 0 &&
			<Box width={'24px'} ml={0.2} display={'flex'} height={'18px'} justifyContent={'center'} alignItems={'center'} borderRadius={'8px'} bgcolor={'#d9f5fb'}>
				<Typography variant='caption' fontWeight='var(--font500)' color='var(--greyColor)'>
					{count !== undefined && count !== null ? count : ''}
				</Typography>
			</Box>}
			{repost &&
			<CreationFieldPopUp
				requestT={'repost'}
				editData={feed}
				OpenPop
				handleClosePop={toggleRepostPopup}
				handleRepostCallback={handleRepostCallback}
			/>
			}
		</Box>
	);
};

export default RepostButton;